








import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ClientConfig from '@/clients/entities/client-config'

@Component
export default class DebugChip extends Vue {
  @Prop()
  private config!: ClientConfig
}
